// src/encounter/structured-note/note-date-model.ts
// PROD-2947 · the pure rules behind note-date-line.tsx (K7, the 6 Oct contract). Kept apart from the component
// (react-refresh).

/** D-45, the house date format. */
export const NOTE_DATE_FORMAT = 'd MMM yyyy';

/** A stored date answer as a Date: a Date, or an ISO string; anything else is no date. */
export function toNoteDate(value: unknown): Date | undefined {
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? undefined : value;
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value)) {
    // A date-only string is a calendar day: read it as local midnight, never as UTC (which can land on the day before).
    const d = /^\d{4}-\d{2}-\d{2}$/.test(value) ? new Date(`${value}T00:00:00`) : new Date(value);
    return Number.isNaN(d.getTime()) ? undefined : d;
  }
  return undefined;
}

/** A template date item (FHIR date / dateTime). */
export const isDateItem = (item: { type?: string }) => item.type === 'date' || item.type === 'dateTime';
